import EmployeesSendMessagesModal from './sidebarComponents/EmployeesSendMessagesModal';
import GenerateEmployeesReportModal from './sidebarComponents/GenerateEmployeesReportModal';

export const getSidebarActions = () => [
  {
    component: GenerateEmployeesReportModal,
    name: 'generate'
  },
  {
    component: EmployeesSendMessagesModal,
    name: 'send'
  }
];
